import * as React from "react";
import { View, StyleSheet } from "react-native";
import IconsYellowBanking from "app/shared/components/icons/icon-yellow-banking/IconsYellowBanking";
import { Caption, Title } from "react-native-paper";
import { useTranslation } from "react-i18next";

interface EmptyBoxProps {
  title?: string;
  subtitle?: string;
  icon?: string;
  componentsPlus?: JSX.Element | JSX.Element[];
}

const EmptyBox = (props: EmptyBoxProps) => {
  const { t } = useTranslation();
  const { title = t("COMMON_KHONG_CO_DU_LIEU"), subtitle = "", componentsPlus = null } = props;
  return (
    <View style={styles.container}>
      {props.icon && <IconsYellowBanking name={props.icon} size={96} />}
      {!props.icon && <IconsYellowBanking name="notify" size={120} />}
      <Title style={styles.fontTitle}>{title}</Title>
      <Caption style={styles.fontSubTitle}>{subtitle}</Caption>
      <>{componentsPlus}</>
    </View>
  );
};

export default EmptyBox;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  fontTitle: {
    fontSize: 18,
    textAlign: "center",
  },
  fontSubTitle: {
    fontSize: 14,
    textAlign: "center",
  },
});
